import React from 'react';
import { Navigate } from 'react-router-dom';
import { useNavbarAccessory } from '@/layout';
import { useIsNarrowViewport } from '@/utils';
import { BranchImportPageView } from './BranchImportPageView';
import { BranchChip } from './components';
import { useBranchImportPage } from './useBranchImportPage';

type BranchImportPageContentProps = {
    branchId: string;
};

/**
 * The page inside its store: an address with no step goes to File, the
 * navbar gets the branch beside its title once the flow runs, and the View
 * renders the rest. On a phone the bar has no room for both, so the chip
 * stays out and the fixed-branch line under the strip names the branch.
 */
export const BranchImportPageContent: React.FC<
    BranchImportPageContentProps
> = ({ branchId }) => {
    const { page, redirectTo } = useBranchImportPage(branchId);
    const isNarrow = useIsNarrowViewport();
    const branchName =
        page.status === 'ready' && !isNarrow ? page.branch.name : null;

    // Memoised on the name: `useNavbarAccessory` stores the node in state, so
    // a fresh element every render would loop.
    const chip = React.useMemo(
        () =>
            branchName === null ? null : <BranchChip branchName={branchName} />,
        [branchName],
    );
    useNavbarAccessory(chip);

    if (redirectTo !== null) {
        return <Navigate replace to={redirectTo} />;
    }

    return <BranchImportPageView page={page} />;
};
